import React from 'react';

function LoadingAnimation() {
  return (
    <div className="loader-wrapper">
      <div className="loader"></div>
    </div>
  );
}

export default LoadingAnimation;
